import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

export type TagProperties = { name?: string; emoji?: string; color?: string; isTagDefault?: boolean };
export type TagUpdateSource = "task-details" | "task-item";
export class CreateTagEvent extends AmplitudeEvent {
    constructor(props: { numTags: number } & TagProperties) {
        super("create_tag");
        this.props = props;
    }
}

export class UpdateTagEvent extends AmplitudeEvent {
    constructor(props: TagProperties & { tagId: string }) {
        super("update_tag");
        this.props = props;
    }
}

export class DeleteTagEvent extends AmplitudeEvent {
    constructor(props: { id: string; name: string }) {
        super("delete_tag");
        this.props = props;
    }
}

export class AssignTaskTagEvent extends AmplitudeEvent {
    constructor(props: {
        taskType: "singular" | "recurring";
        taskId?: string;
        masterId?: string;
        index?: number;
        tagId: string;
        source: TagUpdateSource;
    }) {
        super("assign_task_tag");
        this.props = props;
    }
}

export class RemoveTaskTagEvent extends AmplitudeEvent {
    constructor(props: {
        taskType: "singular" | "recurring";
        taskId?: string;
        masterId?: string;
        index?: number;
        source: TagUpdateSource;
    }) {
        super("remove_task_tag");
        this.props = props;
    }
}
